import { Button, Text, theme } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'
import { CSSProperties } from 'styled-components'

import { useReportPost } from '../common/TogetherDataWrapper/hooks/usePostAction'
import { StyledSubmitReportForm } from './index.styled'

export type Props = {
  className?: string
  style?: CSSProperties
  reason: string
  reasonText: string
  postId?: string
  onClose?: () => void
}

export const SubmitReportForm = ({
  className,
  style,
  reason,
  reasonText,
  postId,
  onClose,
}: // onClose,
// postId,
Props) => {
  const { formatMessage: f } = useIntl()
  const { loading, onReportPost } = useReportPost()
  return (
    <StyledSubmitReportForm className={className} style={style}>
      <ul className="report-list">
        <li className="report-item">
          <img loading="lazy" src="./svg/icon-alert-circle.svg" />
          <Text className="__label" color={theme.colors.gray800} size="p4">
            {reasonText}
          </Text>
        </li>
      </ul>
      <Button
        className="report-submit"
        size="lg"
        color="primary"
        theme="marryBaby"
        isLoading={loading}
        onClick={async () => {
          if (!postId) return
          const res = await onReportPost({
            id: postId,
            reason,
          })
          if (res?.data) {
            onClose && onClose()
          }
        }}
      >
        {f({ id: 'submit' })}
      </Button>
    </StyledSubmitReportForm>
  )
}
